import _ from 'lodash'
import Vue from 'vue'
import config from '@/config'

let theConfig = Object.assign({}, config)

export default {
  namespaced: true,
  state: {
    ...theConfig,
    rootLink: '',
    rootDomain: '',
    allowDatasources: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 250, 260],
    allowPriceListHelp: [],
    uiVersion: 1,
    // TODO@PONY use mobile UI
    // uiVersion: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 2 : 1
    isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false
  },
  mutations: {
    setRootUrl (state, url) {
      state.rootLink = url
      if (process.env.NODE_ENV === 'development') {
        state.rootDomain = '//dev.sl360.com'
      } else {
        state.rootDomain = '//' + window.document.domain
      }
    },
    saveKey (state, val) {
      state[val[0]] = val[1]
    },
    deleteTabType (state, payload, rootState) {
      let type = payload[0]
      let tab = payload[1] || 'geoTabs'
      let scope = payload[2] || 'all'

      if (scope === 'all') { // delete all datasource
        for (let key of Object.keys(state.datasource)) {
          let index = state.datasource[key][tab].indexOf(type)
          if (index !== -1) {
            Vue.delete(state.datasource[key][tab], index)
          }
        }
      } else { // delete current datasource
        let datasource = state.datasource[scope]
        let index = datasource[tab].indexOf(type)
        if (index !== -1) {
          Vue.delete(datasource[tab], index)
        }
      }
    },
    saveDatasourceKey (state, payload) {
      // if (!rootState.order.ListType) return
      // Vue.set(state.datasource[rootState.order.ListType], payload[0], paylodad[1])
    }
  },
  getters: {
    datasource: (state, getters, rootState) => {
      if (!rootState.order.ListType) {
        return {}
      }
      let datasource = Object.assign({}, state.datasource[rootState.order.ListType])
      datasource.geoTabs = _.map(datasource.geoTabs, key => {
        return state.geoType[key]
      })
      // sort moreAreo
      // if (_.findIndex(datasource.geoTabs, item => {
      //   return item.name === 'moreArea'
      // }) > -1) {
      //   datasource.geoTabs = _.map(datasource.geoTabs, item => {
      //     if (item.isMulti && item.sort < 50) {
      //       item.sort += 30
      //     }
      //     return item
      //   })
      // }
      datasource.geoTabs.sort((a, b) => {
        return a.sort - b.sort
      })

      datasource.demoTabs = _.map(datasource.demoTabs, key => {
        return state.demoType[key]
      })
      return datasource
    },
    link: state => name => {
      if (state.link[name].slice(0, 2) === '//') {
        return state.link[name]
      } else {
        return state.rootLink + state.link[name]
      }
    },
    checkDatasource: state => listType => {
      if (isNaN(listType)) return false
      if (!config.dev.isAuth) return true
      return state.allowDatasources.indexOf(parseInt(listType)) >= 0
    },
    checkDemoTab: (state, getters, rootState) => demoType => {
      if (!rootState.order.ListType) return false
      return state.datasource[rootState.order.ListType].demoTabs.hasOwnProperty(demoType)
    },
    checkGeoTab: (state, getters, rootState) => geoType => {
      if (!rootState.order.ListType) return false
      return state.datasource[rootState.order.ListType].geoTabs.hasOwnProperty(geoType)
    },
    wmsLink: (state, getters) => {
      if (window.location.hostname.indexOf('dev') >= 0 || window.location.hostname === 'localhost') {
        return '//mapserivce-aws.usadatadev.com/boundaries/wms?'
      } else {
        return '//app.sl360.com/boundaries/wms?'
      }
    },
    mapDataLink: (state, getters) => {
      if (window.location.hostname.indexOf('dev') >= 0 || window.location.hostname === 'localhost') {
        return '//dev.sl360.com/map/GetData.ashx?'
      } else {
        return '//app.sl360.com/map/GetData.ashx?'
      }
    },
    getOrderFile: (state, getters) => {
      if (window.location.hostname.indexOf('dev') >= 0 || window.location.hostname === 'localhost') {
        return '//listservices-aws.usadatadev.com/orderfile.aspx'
      } else {
        return '//listservices.usadata.com/OrderFile.aspx'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/config/index.js